<div class="order-summary main-padding">
  <h3 class="mb-4">Order summary</h3>

  <div class="light text-medium" *ngIf="orderSummary">
    <div class="d-flex align-items-center justify-content-between">
      <p>{{orderSummary.name}}</p>
      <p>{{orderSummary.price | price}}</p>
    </div>
    <div class="d-flex align-items-center justify-content-between mt-1">
      <p>Commission fee</p>
      <p>{{orderSummary.commission | price}}</p>
    </div>
  </div>
  <hr>
  <div class="semi-bold d-flex align-items-center justify-content-between">
    <p>Total</p>
    <p>{{total | price}}</p>
  </div>
</div>
